import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { Details } from "src/app/interfaces/details.interface";
import { OrganismsService } from "src/app/services/organisms.service";
import { Location } from "@angular/common";

@Component({
  selector: "app-organismos-detalle",
  templateUrl: "./organismos-detalle.component.html",
  styleUrls: ["./organismos-detalle.component.css"],
})
export class OrganismosDetalleComponent implements OnInit {
  public details: Details;
  private id: string = "";
  private subscription: Subscription = new Subscription();

  constructor(
    private service: OrganismsService,
    private location: Location,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get("id") || "";
    if (this.id) {
      this.loadEntityDetail(this.id);
    } else {
      this.close();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public close() {
    this.location.back();
  }

  get emailList(): string[] {
    return this.details?.correos
      ? this.details.correos
          .split(",")
          .map((email) => email.trim())
          .filter((email) => email !== "")
      : [];
  }

  private async loadEntityDetail(id: string): Promise<void> {
    try {
      const details = await this.service.getOrganimsDetails(id);
      this.details = details;
    } catch (error) {
      console.log("error");
    }
  }
}
